export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '';
export const MVP_API_BASE_URL = import.meta.env.VITE_MVP_API_BASE_URL ?? '';
export const apiUrl = import.meta.env.VITE_API_URL ?? '';
export const GA4_JULO = import.meta.env.VITE_GA4_ID_JULO ?? '';
export const APP_ENV = import.meta.env.VITE_ENV_NAME ?? '';
export const GRAB_MODAL_HELP_CENTER =
  'https://help.grab.com/driver/id-id/360025236612-Program-GrabModal-Narik';
